export enum TailorJobStatus {
  SETTING_UP = "Setting Up",
  READY_FOR_PROCESSING = "Ready for Processing",
  PROCESSING = "Processing",
  ERROR = "Error",
  FINISHED = "Finished",
}
